import classNames from "classnames";

export const Checkbox = ({ className, ...props }) => {
    const inputClass = classNames("h-3 w-3 rounded border-gray-300 text-indigo-500 focus:ring-0", className)
    return <input
        type="checkbox"
        className={inputClass}
        {...props}
    />
}
